import format from 'date-fns/format';
import fr from 'date-fns/locale/fr';
import { useMemo } from 'react';

const useFormattedDate = (dateString, locale) => {
    const date = useMemo(
        () =>
            format(
                new Date(dateString),
                locale === 'fr' ? 'd MMMM' : 'MMMM d',
                locale === 'fr' ? { locale: fr } : null,
            ),
        [dateString, locale],
    );

    const hour = useMemo(
        () =>
            format(
                new Date(dateString),
                locale === 'fr' ? 'H:mm' : 'H:mm',
                locale === 'fr' ? { locale: fr } : null,
            ),
        [dateString, locale],
    );

    const year = useMemo(
        () => format(new Date(dateString), 'yyyy', locale === 'fr' ? { locale: fr } : null),
        [dateString, locale],
    );

    return {
        date,
        hour,
        year,
        full: `${date} ${year} — ${hour}`,
    };
};

export default useFormattedDate;
